import * as THREE from 'three';
import React, { useRef, useEffect } from 'react';
import { ILight } from '../lightTemplate';
import { useHelper } from '@react-three/drei';

type ISpotLightProps = {
  instanceId: string;
  castShadow?: boolean;
  light?: ILight | undefined;
};

export const SpotLight = (props: ISpotLightProps) => {
  const lightRef = props.light?.ref;

  const targetRef = useRef<THREE.Object3D>(new THREE.Object3D());

  useEffect(() => {
    lightRef.current.castShadow = props.castShadow;

    lightRef.current.shadow.mapSize.width = props.light?.shadowMapWidth || 512;
    lightRef.current.shadow.mapSize.height =
      props.light?.shadowMapHeight || 512;

    lightRef.current.shadow.camera.near = props.light?.shadowCameraNear || 1;
    lightRef.current.shadow.camera.far = props.light?.shadowCameraFar || 500;

    lightRef.current.shadow.bias = props.light?.shadowBias || -0.002;

    lightRef.current.shadow.needsUpdate = true;
  }, []);

  useHelper(lightRef, THREE.SpotLightHelper, 'white');

  return (
    <>
      <primitive object={targetRef.current} position={[0, 0, 0]} />
      <spotLight
        ref={lightRef}
        color={props.light?.color !== undefined ? props.light.color : 0xffffff}
        intensity={
          props.light?.intensity !== undefined ? props.light.intensity : 1.5
        }
        position={[0, 0.5, 0]}
        decay={props.light?.decay !== undefined ? props.light.decay : 0.0}
        distance={
          props.light?.distance !== undefined ? props.light.distance : 50
        }
        angle={
          props.light?.angle !== undefined ? props.light.angle : Math.PI / 6
        }
        penumbra={
          props.light?.penumbra !== undefined ? props.light.penumbra : 0.5
        }
        castShadow={props.castShadow !== undefined ? props.castShadow : false}

        target={targetRef.current}
        key={`light-${props.instanceId}`}
      />
    </>
  );
};
